import {
  Button,
  Checkbox,
  DrawerBody,
  DrawerFooter,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  Select,
} from '@chakra-ui/react';
import { useState } from 'react';
import { IMaskInput } from 'react-imask';
import { documentMasks } from 'shared/utils/maskOptions';
import { useCreateResellerCustomerModalContext } from '../ModalContext';

interface Props {
  onClose(): void;
}

const InstallationStep: React.FC<Props> = ({ onClose }) => {
  const {
    cnpj,
    installationDocument,
    setInstallationDocument,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    negocio,
    setNegocio,
    installationErrors: errors,
    handleSubmit,
    previousStep,
    loading,
  } = useCreateResellerCustomerModalContext();

  const [useSameDocument, setUseSameDocument] = useState(false);

  const handleToggleSameDocument = () => {
    const next = !useSameDocument;
    setUseSameDocument(next);
    if (next) {
      setInstallationDocument(cnpj);
    } else {
      setInstallationDocument('');
    }
  };

  return (
    <>
      <DrawerBody>
        <Flex columnGap="5%" rowGap="1rem" wrap="wrap">
          <FormControl isRequired isInvalid={!!errors.installationDocument}>
            <FormLabel fontSize="0.8rem" color="gray.500">
              Documento para login
            </FormLabel>
            <Input
              as={IMaskInput}
              placeholder="000.000.000-00"
              mask={documentMasks}
              value={installationDocument}
              onAccept={(value: string) => setInstallationDocument(value)}
              type="text"
            />
            {errors.installationDocument && (
              <FormErrorMessage>{errors.installationDocument}</FormErrorMessage>
            )}
            <HStack mt="0.5rem">
              <Checkbox
                isChecked={useSameDocument}
                onChange={handleToggleSameDocument}
                colorScheme="yooga"
                size="sm"
              />
              <FormLabel
                mb={0}
                fontSize="0.75rem"
                color="gray.500"
                cursor="pointer"
                onClick={handleToggleSameDocument}
              >
                Utilizar o mesmo documento do cliente?
              </FormLabel>
            </HStack>
          </FormControl>

          <FormControl isRequired isInvalid={!!errors.password}>
            <FormLabel fontSize="0.8rem" color="gray.500">
              Senha
            </FormLabel>
            <Input
              autoComplete="new-password"
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              value={password}
            />
            {errors.password && (
              <FormErrorMessage>{errors.password}</FormErrorMessage>
            )}
          </FormControl>

          <FormControl isRequired isInvalid={!!errors.confirmPassword}>
            <FormLabel fontSize="0.8rem" color="gray.500">
              Confirme a senha
            </FormLabel>
            <Input
              autoComplete="new-password"
              onChange={(e) => setConfirmPassword(e.target.value)}
              type="password"
              value={confirmPassword}
            />
            {errors.confirmPassword && (
              <FormErrorMessage>{errors.confirmPassword}</FormErrorMessage>
            )}
          </FormControl>

          <FormControl isRequired isInvalid={!!errors.negocio}>
            <FormLabel fontSize="0.8rem" color="gray.500">
              Tipo do estabelecimento
            </FormLabel>
            <Select
              value={negocio}
              onChange={(e) => setNegocio(e.target.value)}
              placeholder="Selecione o tipo do estabelecimento"
            >
              <option value="Outros">Em branco</option>
              <option value="Restaurante">Restaurante</option>
              <option value="Hamburgueria">Lanchonete</option>
              <option value="Hamburgueria">Hamburgueria</option>
              <option value="Doceria">Doceria</option>
              <option value="Açaiteria">Açaiteria</option>
              <option value="Pizzaria">Pizzaria</option>
              <option value="Bar / Petiscaria">Bar / Petiscaria</option>
              <option value="Saladeria">Saladeria</option>
              <option value="Distribuidora de Bebidas">
                Distribuidora de Bebidas
              </option>
              <option value="Padaria / Cafeteria">Padaria</option>
              <option value="Padaria / Cafeteria">Cafeteria</option>
              <option value="Sorveteria">Sorveteria</option>
              <option value="Comida Oriental">Comida Oriental</option>
              <option value="Neutro">Outros</option>
            </Select>
            {errors.negocio && (
              <FormErrorMessage>{errors.negocio}</FormErrorMessage>
            )}
          </FormControl>
        </Flex>
      </DrawerBody>

      <DrawerFooter gap="1rem">
        <Button variant="outline" onClick={previousStep} flex="1">
          Voltar
        </Button>
        <Button
          colorScheme="yooga"
          onClick={handleSubmit}
          flex="1"
          isDisabled={loading}
        >
          Criar Cliente
        </Button>
      </DrawerFooter>
    </>
  );
};

export default InstallationStep;
